import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import StarIcon from '@mui/icons-material/Star';
import {
  Button,
  DialogActions,
  Tooltip,
  // List,
  // ListItem,
  // ListItemText,
  Typography,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { Box, Stack } from '@mui/system';
import * as React from 'react';
import useClipboard from 'react-use-clipboard';

import { useBasicExitIntent } from '@/hooks/useBasicExitIntent';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const ExitPopup1065 = (): React.JSX.Element => {
  const [open, setOpen] = React.useState(false);

  useBasicExitIntent(() => {
    setOpen(true);
  });

  const handleClose = () => {
    sessionStorage.setItem('tzo-exit-intent', 'exit');
    setOpen(false);
  };
  const [isCopied, setCopied] = useClipboard('TZOBIZ10', {
    successDuration: 6000,
  });
  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      className="holiday-theme"
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleClose}
      />
      <DialogContent>
        <Box component="div" sx={{ textAlign: 'center', mt: 0 }}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2, md: 2 }}
            alignItems="center"
            justifyContent="space-around"
            sx={{ px: { xs: 0, sm: 1 }, mb: 1 }}
          >
            <Box
              component="img"
              src="/assets/images/wait-img.png"
              loading="lazy"
              alt="Attention S-Corp Owners"
              width={130}
              height={106}
            />

            <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
              <Typography
                variant="body1"
                color="primary"
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: 18, sm: 24, md: 30 },
                  color: '#da4b4b',
                }}
              >
                Wait! Before You Go!
              </Typography>
              <Typography
                variant="body1"
                color="primary"
                sx={{
                  color: '#333',
                }}
              >
                File your{' '}
                <span style={{ color: '#333', fontWeight: 700 }}>
                  2025 Form 1065
                </span>{' '}
                with us &{' '}
                <span style={{ color: '#333', fontWeight: 700 }}>
                  {' '}
                  Grab 10% off
                </span>
              </Typography>
            </Box>
          </Stack>

          <Stack
            direction={{ xs: 'column', sm: 'column' }}
            spacing={{ xs: 1, sm: 2, md: 4 }}
            sx={{ borderTop: '1px solid #ccc', mt: 1 }}
          >
            <Box
              component="ul"
              sx={{
                listStyleType: 'none',
                pl: { xs: 4, sm: 2 },
                mb: 1,
                mt: '14px !important',
              }}
            >
              <Box
                component="li"
                sx={{
                  display: { xs: 'inline-block', sm: 'flex' },
                  alignItems: 'center',
                  mb: 1.25,
                  textIndent: { xs: '-30px', sm: 0 },
                  textAlign: 'left',
                }}
              >
                <CheckCircleRoundedIcon
                  sx={{
                    mr: 1,
                    color: '#1da94a',
                    mb: { xs: -0.8, sm: 0 },
                  }}
                />
                Real-time IRS submission confirmation
              </Box>
              <Box
                component="li"
                sx={{
                  display: { xs: 'inline-block', sm: 'flex' },
                  alignItems: 'flex-start',
                  mb: 1.25,
                  textIndent: { xs: '-30px', sm: 0 },
                  textAlign: 'left',
                }}
              >
                <CheckCircleRoundedIcon
                  sx={{
                    mr: 1,
                    color: '#1da94a',
                    mb: { xs: -0.8, sm: 0 },
                  }}
                />
                Instantly deliver K-1s to all partners
              </Box>
              <Box
                component="li"
                sx={{
                  display: { xs: 'inline-block', sm: 'flex' },
                  alignItems: 'center',
                  mb: 1.25,
                  textIndent: { xs: '-30px', sm: 0 },
                  textAlign: 'left',
                }}
              >
                <CheckCircleRoundedIcon
                  sx={{
                    mr: 1,
                    color: '#1da94a',
                    mb: { xs: -0.8, sm: 0 },
                  }}
                />
                Built-in IRS validation to help prevent errors
              </Box>
            </Box>
          </Stack>
          <Box
            sx={{
              m: 0,
              mx: 'auto',
              mb: 1,
              maxWidth: 450,
              p: 1,
              fontSize: { xs: 11, sm: 12, md: 18 },
              fontWeight: 400,
              lineHeight: 1.2,
              border: '2px dashed rgb(113, 81, 0)',
              backgroundColor: 'rgb(255, 250, 205)',
            }}
          >
            {' '}
            Use code {/* <Stack spacing={1} direction="row"> */}
            <Box
              component="strong"
              sx={{
                ml: 0,
                color: '#fd5345',
                fontWeight: 600,
                fontSize: { xs: 18, sm: 19, md: 22 },
              }}
            >
              TZOBIZ10
            </Box>{' '}
            <Tooltip title={isCopied ? 'Copied' : 'Copy to Clipboard'} arrow>
              <IconButton onClick={setCopied} sx={{ mt: '-6px !important' }}>
                <ContentCopyIcon sx={{ fontSize: 22 }} />
              </IconButton>
            </Tooltip>
            {/* </Stack> */}
            at checkout to <br style={{ marginBottom: 10 }} />
            <span style={{ fontWeight: 600 }}>Save 10%</span> on your filing
            Fee!{' '}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: 'center',
          pb: '24px !important',
          textAlign: 'center',
          backgroundColor: '#f9f9f9',
          borderTop: '1px solid #ccc',
        }}
      >
        <Box sx={{ px: { xs: 1, sm: 3 }, mt: 1 }}>
          <Typography
            variant="body1"
            sx={{ fontSize: 16, fontWeight: 500, mb: 1 }}
          >
            Don&apos;t risk late penalties
          </Typography>
          <Button
            variant="contained"
            size="large"
            // className="btn-primary"
            sx={{
              textTransform: 'none',
              boxShadow: 'none',
              borderRadius: 4,
              display: 'inline-block',
              fontSize: { xs: 18, sm: 20, md: 22, lg: 24 },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1065`}
          >
            E-file & Save 10%
          </Button>
        </Box>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default ExitPopup1065;
